(function($) {
	$(function () {

        const $document = $(document)
        const $modal = $('.modal')

        $modal.each(function() {
            const $currentModal = $(this)
            const modalId = $currentModal.attr('id') 

            if (!modalId) return

            $(`a[href="#${modalId}"]`).on('click', openModal)
            $currentModal.find('.modal__close, .modal__overlay').on('click', closeModal)

            function handleKeydown(e) {
                if (e.key === 'Escape' || e.keyCode === 27) {
                    closeModal()
                }
            }

            function openModal(e) {
                e.preventDefault()
                e.stopPropagation()
                $currentModal.fadeIn()
                $document.on('keydown', handleKeydown)
                $('.modal__close').focus()
            }

            function closeModal() {
                $currentModal.fadeOut()
                $document.off('keydown', handleKeydown)
            }
        })
        
        
	})
})(window.jQuery)
